import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { PersistGate } from "redux-persist/lib/integration/react";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./app/store.js";

// IMPORT FONTS
import "./fonts/SignPainter.otf";
import "./fonts/SignPainter.ttf";
import "./fonts/SignPainter.woff";
import "./fonts/SignPainter.woff2";
import "./fonts/font.css";
import "./fonts/Bradley/Bradley.eot";
import "./fonts/Bradley/Bradley.otf";
import "./fonts/Bradley/Bradley.svg";
import "./fonts/Bradley/Bradley.ttf";
import "./fonts/Bradley/Bradley.woff";
import "./fonts/Bradley/Bradley.woff2";
import "./fonts/Bradley/font.css";
import "./fonts/Undercurrent/font.css";
import "./fonts/Undercurrent/Undercurrent_20BTN.eot";
import "./fonts/Undercurrent/Undercurrent_20BTN.woff2";
import "./fonts/Undercurrent/UndercurrentBTN.otf";
import "./fonts/Undercurrent/UndercurrentBTN.svg";
import "./fonts/Undercurrent/UndercurrentBTN.ttf";
import "./fonts/Undercurrent/UndercurrentBTN.woff";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
